export default {
    icon: "el-icon-discount",
    title: "精选推荐",
    name: "promotionList",
    timestamp: "1709627778508010",
    setUp: {
        tabVal: 0
    },
    productList: {
        title: "促销列表",
        list: []
    },
    titleConfig: {
        title: "标题位置",
        type: 2,
        list: [
            {
                val: "居左",
                icon: "icondoc_left"
            },
            {
                val: "居中",
                icon: "icondoc_center"
            },
            {
                val: "居右",
                icon: "icondoc_right"
            }
        ]
    },
    titleShow: {
        title: "是否显示商品名称",
        val: true
    },
    opriceShow: {
        title: "是否显示商品原价",
        val: true
    },
    priceShow: {
        title: "是否显示商品价格",
        val: true
    },
    couponShow: {
        title: "是否显示优惠券",
        val: true
    },
    tabConfig: {
        title: "选择显示模式",
        tabVal: 0,
        type: 0,
        list: [
            {
                name: "精选商品",
                icon: "el-icon-setting"
            },
            {
                name: "推荐商品",
                icon: "el-icon-thumb"
            }
        ]
    },
    themeColor: {
        title: "主题风格",
        name: "themeColor",
        default: [
            {
                item: "#F95429"
            }
        ],
        color: [
            {
                item: "#F95429"
            }
        ]
    },
    fontColor: {
        title: "价格颜色",
        name: "fontColor",
        default: [
            {
                item: "#e93323"
            }
        ],
        color: [
            {
                item: "rgba(253,80,47,1)"
            }
        ]
    },
    labelColor: {
        title: "活动标签",
        name: "labelColor",
        default: [
            {
                item: "#e93323"
            }
        ],
        color: [
            {
                item: "#e93323"
            }
        ]
    },
    mbConfig: {
        title: "页面间距",
        val: 10,
        min: 0
    },
    numConfig: {
        val: 9
    },
    id: "id1709627778508010"
}